import {Component, Input} from "@angular/core";
import {TeVariableProviderService} from "../service/api/interfaces/te-variable-provider.service";
import {TeContentTypeEnum} from "../enum/te-content-type.enum";
import {MvsCrudService} from "../../../core/shared/service/crud/mvs-crud.service";

@Component({
    selector: "te-variable-component-base",
    template: "Template variable component base",
    standalone: false
})
export class TeVariableComponentBase {
  @Input() contentType: TeContentTypeEnum;
  @Input() contentProviderId: number;
  @Input() variableProviderService: MvsCrudService & TeVariableProviderService | any;
  @Input() alias: string;
  @Input() attributeName: string;
}
